import { c as _c } from "react/compiler-runtime";
import { MutableRefObject, useCallback } from 'react';
import { useEventListener } from './useEventListener';
import { useRefWithCurrentValue } from './useRefWithCurrentValue';
export function useOnOutsideClick(elements, callback) {
  const $ = _c(3);
  const elementsRef = useRefWithCurrentValue(elements);
  const callbackRef = useRefWithCurrentValue(callback);
  let t0;
  if ($[0] !== callbackRef || $[1] !== elementsRef) {
    t0 = event => {
      const {
        target
      } = event;
      if (target && target instanceof Node) {
        const atLeastOneElementContainsTarget = elementsRef.current.some(e => e.current && e.current.contains(target));
        if (!atLeastOneElementContainsTarget) {
          callbackRef.current();
        }
      }
    };
    $[0] = callbackRef;
    $[1] = elementsRef;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const clickHandler = t0;
  useEventListener(document, "click", clickHandler);
}